export const isException = status => status === 'Exception';
